import classNames from "classnames"
import React, { HTMLAttributes } from "react"

export const ToggleSwitch = ({
    isToggled,
    setIsToggled,
    className,
    isError,
    disabled = false,
    isLight = false,
    ballStyle,
    shouldStopPropogation,
    ...rest
}: {
    isToggled: boolean
    setIsToggled: (isEnabled: boolean) => void
    isError?: boolean
    disabled?: boolean
    isLight?: boolean
    ballStyle?: string
    shouldStopPropogation?: boolean
} & HTMLAttributes<HTMLDivElement>) => {
    return (
        <div
            className={classNames(
                "ml-1 flex w-7 h-4 rounded-full border items-center pl-0.5 group",
                {
                    "border-gray-300 cursor-pointer": !isError && !disabled,
                    "border-gray-500": disabled && !isError,
                    "border-orange-500": isError,
                    "cursor-not-allowed": disabled,
                },
                className
            )}
            onClick={(e) => {
                setIsToggled(!isToggled)
                //used in the case where the switcher is also on top of a accordion button, we don't want double clicks
                if (shouldStopPropogation) e.stopPropagation()
            }}
            {...rest}
        >
            <div
                className={classNames(
                    "rounded-full w-2.5 h-2.5 transition-transform duration-150 ease-in-out",
                    {
                        "bg-gray-100 group-hover:bg-gray-0": !isToggled && !disabled && !isLight,
                        "bg-gray-200 group-hover:bg-gray-400": !isToggled && !disabled && isLight,
                        [ballStyle ?? "bg-green-500"]: isToggled && !isError && !disabled,
                        "bg-gray-500": !isError && disabled,
                        "bg-gray-300": isError,
                    }
                )}
                style={{
                    transform: isToggled ? "translateX(calc(100% + 0.125rem))" : undefined,
                    willChange: "transform",
                }}
            />
        </div>
    )
}
